import { blueGrey } from "@mui/material/colors";
import {
  DeleteIcon,
  GKButton,
  GKClientDataGrid,
  GKSearchSelect,
  GKTextField,
  Grid2,
  IconButton,
  Typography,
  UploadIcon,
} from "components";
import { AdvisorOnboardFormInterface } from "interfaces/OnboardingInterface";
import { isEmpty } from "lodash";
import { useState } from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import { useAppSelector } from "store/store";
import { handleReturnNaturalRows } from "utils";
import UploadHoldingsModal from "./UploadHoldingsModal";

const PlansHoldings = () => {
  const { control, getValues, setValue } =
    useFormContext<AdvisorOnboardFormInterface>();

  const companies = useAppSelector((state) => state?.app?.companies);

  const [uploadHoldingsModal, setUploadHoldingsModal] = useState(false);

  const { fields, insert } = useFieldArray({
    name: "planDataObject.plansHoldings",
    control,
  });

  return (
    <>
      <Grid2 container spacing={2}>
        <Grid2 size={12} display={"flex"} alignItems={"center"} gap={1}>
          <Typography fontWeight={600}>Add holdings manually </Typography>
          <Typography fontWeight={600} color={blueGrey[500]}>
            OR
          </Typography>
          <GKButton
            startIcon={<UploadIcon width={16} height={16} />}
            variant="outlined"
            color="dark"
            onClick={() => {
              setUploadHoldingsModal(true);
            }}
          >
            Upload via excel
          </GKButton>
        </Grid2>
        <Grid2 size={12} />
        <Grid2 size={12}>
          <GKClientDataGrid
            pagination
            columnHeaderHeight={36}
            disableRowSelectionOnClick
            maxHeight={`calc(100vh - 450px)`}
            name="plansHoldings"
            getRowClassName={(params) => {
              return isEmpty(params.row.gridCode) || +params.row.quantity === 0
                ? "error-row"
                : "";
            }}
            rows={
              fields?.map((d: any, index: any) => {
                return {
                  ...d,
                  index: index,
                };
              }) || []
            }
            headerComponent={
              <GKButton
                variant="outlined"
                size="small"
                onClick={() => {
                  insert(0, {
                    gridCode: "",
                    name: "",
                    quantity: 0,
                    cmp: "",
                    id: getValues("planDataObject.plansHoldings")?.length,
                  });
                }}
              >
                Add Stock
              </GKButton>
            }
            columns={[
              {
                field: "gridCode",
                headerName: "Company Name",
                minWidth: 300,
                disableColumnMenu: true,
                renderCell: (params: any) => {
                  return (
                    <Controller
                      name={`planDataObject.plansHoldings.${params?.row?.index}.gridCode`}
                      control={control}
                      render={({ field }) => {
                        return (
                          <GKSearchSelect
                            {...field}
                            size="small"
                            getOptionLabel={(opt) => opt?.name || opt}
                            options={
                              handleReturnNaturalRows({
                                options: companies,
                                optionsValueKey: "gridCode",
                                selectedValueKey: "gridCode",
                                values: getValues(
                                  "planDataObject.plansHoldings",
                                ),
                              }) || []
                            }
                            value={
                              companies?.find((d) => field.value === d.value)
                                ?.name
                            }
                            onChange={(_, val) => {
                              field.onChange(val.value);
                              setValue(
                                `planDataObject.plansHoldings.${params?.row?.index}.cmp`,
                                val?.cmp,
                              );
                              setValue(
                                `planDataObject.plansHoldings.${params?.row?.index}.name`,
                                val?.name,
                              );
                            }}
                            sx={{
                              width: "100%",
                            }}
                          />
                        );
                      }}
                    />
                  );
                },
              },
              {
                field: "quantity",
                headerName: "Quantity",
                minWidth: 120,
                disableColumnMenu: true,
                renderCell: (params: any) => {
                  return (
                    <Controller
                      name={`planDataObject.plansHoldings.${params?.row?.index}.quantity`}
                      control={control}
                      rules={{
                        required: {
                          value: true,
                          message: "",
                        },
                      }}
                      render={({ field }) => {
                        return (
                          <GKTextField
                            {...field}
                            size="small"
                            placeholder="Enter quantity"
                          />
                        );
                      }}
                    />
                  );
                },
              },
              {
                headerName: "CMP",
                field: "cmp",
                flex: 1,
                disableColumnMenu: true,
                renderCell: (params) => {
                  return (
                    <Controller
                      name={`planDataObject.plansHoldings.${params?.row?.index}.cmp`}
                      control={control}
                      render={({ field }) => {
                        return <Typography>{field?.value}</Typography>;
                      }}
                    />
                  );
                },
              },
              {
                headerName: "Action",
                headerAlign: "right",
                align: "right",
                field: "action",
                flex: 1,
                disableColumnMenu: true,
                renderCell: ({ row }: { row: any }) => {
                  return (
                    <IconButton
                      color="error"
                      onClick={() => {
                        const filterData = getValues(
                          "planDataObject.plansHoldings",
                        )?.filter((_: any, i: any) => i !== row.index);
                        setValue("planDataObject.plansHoldings", filterData);
                      }}
                    >
                      <DeleteIcon width={18} height={18} />
                    </IconButton>
                  );
                },
              },
            ]}
          />
        </Grid2>
      </Grid2>
      {uploadHoldingsModal && (
        <UploadHoldingsModal
          setOpen={setUploadHoldingsModal}
          open={uploadHoldingsModal}
        />
      )}
    </>
  );
};

export default PlansHoldings;
